(() => {
  if (customElements.get('video-player')) {
    return;
  }

  class VideoPlayer extends HTMLElement {
    constructor() {
      super();

      this.querySelector('[data-button-play]').addEventListener('click', () => {
        this.querySelector('video').play();
        this.querySelector('video').setAttribute('controls', true);
        this.classList.add('playing');
      })
    }
  }

  customElements.define('video-player', VideoPlayer);
})();
